import { render, staticRenderFns } from "./question-explanation.vue?vue&type=template&id=38897706&"
import script from "./question-explanation.vue?vue&type=script&lang=js&"
export * from "./question-explanation.vue?vue&type=script&lang=js&"
import style0 from "./question-explanation.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports